$('#order-number').change(function(){
    $('#previously_invoiced_to_date').val($(this).children('option:selected').data('invoiced-value'));
});
